import { CommitmentsDeathService_deathServiceGetClaims } from '@festina/life-general-types/life/hooks/CommitmentsDeathService_deathServiceGetClaims'

export const useFetchDeathClaims =
  CommitmentsDeathService_deathServiceGetClaims.useSuspenseQuery
